import { Link } from "react-router-dom";

interface SmsConsentFieldProps {
  value: string;
  onChange: (val: string) => void;
  /** Use light variant for dark backgrounds (default), or "dark" for light backgrounds */
  variant?: "light" | "dark";
}

const SmsConsentField = ({ value, onChange, variant = "light" }: SmsConsentFieldProps) => {
  const textClass = variant === "light" ? "text-primary-foreground/60" : "text-muted-foreground";
  const labelClass = variant === "light" ? "text-primary-foreground/80" : "text-foreground/80";
  const radioRing = variant === "light" ? "border-primary-foreground/30" : "border-border";
  const radioChecked = "bg-primary border-primary";

  return (
    <div className="space-y-1.5">
      <p className={`text-[10px] leading-[1.2] ${textClass}`}>
        By checking the box below, you agree to receive recurring Customer Care and Informational text messages from 1 Wood Floors. Message frequency varies. Message and data rates may apply. Reply HELP for help and STOP to opt out. View our Privacy Policy and Terms at https://1woodfloors.com/privacy-policy.
      </p>

      <div className="space-y-1.5">
        <label className={`flex items-start gap-2.5 cursor-pointer text-xs ${labelClass}`}>
          <span
            className={`mt-0.5 w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${
              value === "yes" ? radioChecked : radioRing
            }`}
            onClick={() => onChange("yes")}
          >
            {value === "yes" && <span className="w-1.5 h-1.5 rounded-full bg-primary-foreground" />}
          </span>
          <span onClick={() => onChange("yes")}>
            Yes, I agree to receive recurring Customer Care and Informational text messages from 1 Wood Floors. Message frequency varies. Message and data rates may apply. Reply HELP for help and STOP to opt out.
          </span>
        </label>

        <label className={`flex items-start gap-2.5 cursor-pointer text-xs ${labelClass}`}>
          <span
            className={`mt-0.5 w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${
              value === "no" ? radioChecked : radioRing
            }`}
            onClick={() => onChange("no")}
          >
            {value === "no" && <span className="w-1.5 h-1.5 rounded-full bg-primary-foreground" />}
          </span>
          <span onClick={() => onChange("no")}>
            No, I don't want to receive text messages from First Class Floor Covering, INC / 1 Wood Floors.
          </span>
        </label>
      </div>

      <p className={`text-[10px] ${textClass}`}>
        See our{" "}
        <Link to="/privacy-policy" className="underline hover:text-primary transition-colors">
          Privacy Policy
        </Link>{" "}
        for details on how we handle your information.
      </p>
    </div>
  );
};

export default SmsConsentField;
